import {
  MOUNT,
  UNMOUNT,
  UPDATE_REDIRECT,
  SUBMIT,
} from './constants'

const updateRedirect = redirect => ({ type: UPDATE_REDIRECT, redirect })
const clearRedirect = () => updateRedirect(false)
const mount = () => ({ type: MOUNT })
const unmount = () => ({ type: UNMOUNT })
const submit = (projectId, workflowId) => ({ type: SUBMIT, projectId, workflowId })

export {
  updateRedirect,
  clearRedirect,
  mount,
  unmount,
  submit,
}
